// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.amenities.RentalManagerUserPropertyAmenityWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias, UserPropertyAmenityCreateResponseWebDto } from '../..';

interface CreateParams {
  listingAlias: ListingAlias;
  text: string;
}
interface DeleteParams {
  amenityId: string;
}

export const RentalManagerUserPropertyAmenityWebApiHandler_create_Path =
  '/api/web/v1/users/properties/amenities/create';

/**
 * Create a free text property amenity
 * @deprecated
 */
export const RentalManagerUserPropertyAmenityWebApiHandler_create = (getParams: CreateParams, client = getClient()) => {
  return httpFrontEndRequest<CreateParams, never, UserPropertyAmenityCreateResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyAmenityWebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyAmenityWebApiHandler_delete_Path =
  '/api/web/v1/users/properties/amenities/delete';

/**
 * Delete a free text property amenity
 * @deprecated
 */
export const RentalManagerUserPropertyAmenityWebApiHandler_delete = (getParams: DeleteParams, client = getClient()) => {
  return httpFrontEndRequest<DeleteParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyAmenityWebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
